import { cloneElement } from 'react';
import PropTypes from 'prop-types';

const FormControlTemplate = ({
    fieldSetting,
    handleButtonClick
}) => {
    if (!fieldSetting?.isFormControl) return null;

    return cloneElement(fieldSetting.formControltemplate, {
        onClick: () => handleButtonClick(fieldSetting.formControltemplate?.props?.actionName),
        isDisable: fieldSetting?.isTemplateBtnDisable,
    });
};

FormControlTemplate.propTypes = {
    fieldSetting: PropTypes.shape({
        isFormControl: PropTypes.bool,
        formControltemplate: PropTypes.shape({
            props: PropTypes.shape({
                actionName: PropTypes.string,
            }).isRequired,
        }).isRequired,
        isTemplateBtnDisable: PropTypes.bool,
    }),
    handleButtonClick: PropTypes.func.isRequired,
};
export default FormControlTemplate;
